/* eslint-disable prettier/prettier */
import URL from './url'
export default class URL_INFO {
    constructor(_p) {
        this.source = new URL()
        this.extracted = new URL()
        if (_p.source) { this.source.url = _p.source }
    }
  }
  